import { render } from "./Menu.vue?vue&type=template&id=451bd207&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=451bd207&scoped=true&lang=css"

import exportComponent from "/Users/enrico/Projects/perlamare/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-451bd207"]])

export default __exports__